
import { useEffect, useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Sun, MonitorSmartphone, BatteryCharging, WifiOff } from "lucide-react";
import { SistemaForm } from "./SistemaForm";

interface ConfigAutoSectionProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
  painelImagePreviewTradicional: string;
  inversorImagePreviewTradicional: string;
  painelImagePreviewMLPE: string;
  inversorImagePreviewMLPE: string;
  painelImagePreviewHibrido: string;
  inversorImagePreviewHibrido: string;
  painelImagePreviewOffGrid: string;
  inversorImagePreviewOffGrid: string;
  setPainelImagePreviewTradicional: (url: string) => void;
  setInversorImagePreviewTradicional: (url: string) => void;
  setPainelImagePreviewMLPE: (url: string) => void;
  setInversorImagePreviewMLPE: (url: string) => void;
  setPainelImagePreviewHibrido: (url: string) => void;
  setInversorImagePreviewHibrido: (url: string) => void;
  setPainelImagePreviewOffGrid: (url: string) => void;
  setInversorImagePreviewOffGrid: (url: string) => void;
  setPainelImageTradicional: (file: File | null) => void;
  setInversorImageTradicional: (file: File | null) => void;
  setPainelImageMLPE: (file: File | null) => void;
  setInversorImageMLPE: (file: File | null) => void;
  setPainelImageHibrido: (file: File | null) => void;
  setInversorImageHibrido: (file: File | null) => void;
  setPainelImageOffGrid: (file: File | null) => void;
  setInversorImageOffGrid: (file: File | null) => void;
  handleFileUpload: (
    e: React.ChangeEvent<HTMLInputElement>, 
    setFile: (file: File | null) => void, 
    setPreview: (url: string) => void, 
    setFormValue: (value: string) => void
  ) => void;
}

export const ConfigAutoSection = ({
  activeTab,
  setActiveTab,
  painelImagePreviewTradicional,
  inversorImagePreviewTradicional,
  painelImagePreviewMLPE,
  inversorImagePreviewMLPE,
  painelImagePreviewHibrido,
  inversorImagePreviewHibrido,
  painelImagePreviewOffGrid,
  inversorImagePreviewOffGrid,
  setPainelImagePreviewTradicional,
  setInversorImagePreviewTradicional,
  setPainelImagePreviewMLPE,
  setInversorImagePreviewMLPE,
  setPainelImagePreviewHibrido,
  setInversorImagePreviewHibrido,
  setPainelImagePreviewOffGrid,
  setInversorImagePreviewOffGrid,
  setPainelImageTradicional,
  setInversorImageTradicional,
  setPainelImageMLPE,
  setInversorImageMLPE,
  setPainelImageHibrido,
  setInversorImageHibrido,
  setPainelImageOffGrid,
  setInversorImageOffGrid,
  handleFileUpload
}: ConfigAutoSectionProps) => {
  return (
    <Tabs value={activeTab} onValueChange={setActiveTab} className="mt-6">
      <TabsList className="grid grid-cols-4 gap-4 w-full h-auto p-1">
        <TabsTrigger 
          value="tradicional" 
          className="flex flex-col gap-1 py-3 md:py-4 data-[state=active]:bg-green-50 data-[state=active]:text-green-700"
        >
          <Sun className="h-5 w-5" />
          <span className="text-xs sm:text-sm">Tradicional</span>
        </TabsTrigger>
        <TabsTrigger 
          value="mlpe" 
          className="flex flex-col gap-1 py-3 md:py-4 data-[state=active]:bg-green-50 data-[state=active]:text-green-700"
        >
          <MonitorSmartphone className="h-5 w-5" />
          <span className="text-xs sm:text-sm">MLPE</span>
        </TabsTrigger>
        <TabsTrigger 
          value="hibrido" 
          className="flex flex-col gap-1 py-3 md:py-4 data-[state=active]:bg-green-50 data-[state=active]:text-green-700"
        >
          <BatteryCharging className="h-5 w-5" />
          <span className="text-xs sm:text-sm">Híbrido</span>
        </TabsTrigger>
        <TabsTrigger 
          value="offgrid" 
          className="flex flex-col gap-1 py-3 md:py-4 data-[state=active]:bg-green-50 data-[state=active]:text-green-700"
        >
          <WifiOff className="h-5 w-5" />
          <span className="text-xs sm:text-sm">Off-Grid</span>
        </TabsTrigger>
      </TabsList>
      
      <div className="mt-6">
        <TabsContent value="tradicional">
          <SistemaForm 
            tipo="tradicional"
            painelImagePreview={painelImagePreviewTradicional}
            inversorImagePreview={inversorImagePreviewTradicional}
            setPainelImagePreview={setPainelImagePreviewTradicional}
            setInversorImagePreview={setInversorImagePreviewTradicional}
            setPainelImage={setPainelImageTradicional}
            setInversorImage={setInversorImageTradicional}
            handleFileUpload={handleFileUpload}
          />
        </TabsContent>
        
        <TabsContent value="mlpe">
          <SistemaForm 
            tipo="mlpe"
            painelImagePreview={painelImagePreviewMLPE}
            inversorImagePreview={inversorImagePreviewMLPE}
            setPainelImagePreview={setPainelImagePreviewMLPE}
            setInversorImagePreview={setInversorImagePreviewMLPE}
            setPainelImage={setPainelImageMLPE}
            setInversorImage={setInversorImageMLPE}
            handleFileUpload={handleFileUpload}
          />
        </TabsContent>
        
        <TabsContent value="hibrido">
          <SistemaForm 
            tipo="hibrido"
            painelImagePreview={painelImagePreviewHibrido}
            inversorImagePreview={inversorImagePreviewHibrido}
            setPainelImagePreview={setPainelImagePreviewHibrido}
            setInversorImagePreview={setInversorImagePreviewHibrido}
            setPainelImage={setPainelImageHibrido}
            setInversorImage={setInversorImageHibrido}
            handleFileUpload={handleFileUpload}
          />
        </TabsContent>
        
        <TabsContent value="offgrid">
          <SistemaForm 
            tipo="offgrid"
            painelImagePreview={painelImagePreviewOffGrid}
            inversorImagePreview={inversorImagePreviewOffGrid}
            setPainelImagePreview={setPainelImagePreviewOffGrid}
            setInversorImagePreview={setInversorImagePreviewOffGrid}
            setPainelImage={setPainelImageOffGrid}
            setInversorImage={setInversorImageOffGrid}
            handleFileUpload={handleFileUpload}
          />
        </TabsContent>
      </div>
    </Tabs>
  );
};
